<template>
  <VRow>
    <template v-for="(item, key) in getCommunesGroupItems">
      <VCol
        :key="`Commune${key}`"
        class="py-3"
        cols="12"
        lg="3"
        md="4"
        sm="6"
        xs="12"
      >
        <CommuneGroupItem :communeGroup="item" />
      </VCol>
    </template>
  </VRow>
</template>

<script lang="ts">
export default {
  name: 'NightCardList',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import CommuneGroupItem from './CommuneGroupItem.vue';

const props = defineProps({
  communesList: {
    type: Array,
    default: () => [],
  },
});

const getCommunesGroupItems = computed(() => {
  const communeGroups = (props.communesList as any[]).reduce((accumulator: any[], currentValue: any) => {
    const { Title, OutOfService, Slug } = currentValue;
    const dataToSet = {
      title: Title,
      isOutOfService: !!OutOfService,
      slug: Slug,
    };
    const firstLetter = Title[0].toLowerCase();
    const letterGroup = accumulator.find((item) => item.letter === firstLetter);
    if (letterGroup) {
      letterGroup.items.push(dataToSet);
    } else {
      const groupItem = {
        letter: firstLetter,
        items: [dataToSet],
      };
      accumulator.push(groupItem);
    }
    return accumulator;
  }, []);
  return communeGroups.sort((a: { letter: string }, b: { letter: string }) => {
    if (a.letter < b.letter) { return -1; }
    if (a.letter > b.letter) { return 1; }
    return 0;
  });
});
</script>

<style scoped>

</style>
